import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo, hasMany } from 'ember-data/relationships';
import { computed } from '@ember/object';
import { filterBy, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import MomentService from 'cio/services/moment';
import CampaignModel from 'cio/models/campaign';
import ActionModel from 'cio/models/action';
import { modelApiAction } from 'cio/utils/model-api-actions';
import DS from 'ember-data';

export default class BroadcastTriggerModel extends Model {
  @service moment!: MomentService;

  @belongsTo('campaign', { async: true, inverse: 'broadcastTriggers' }) campaign!: CampaignModel;
  @computed('campaign')
  get campaignId() {
    return (this as BroadcastTriggerModel).belongsTo('campaign').id();
  }
  @attr('number') createdAt!: number;
  @attr('number') recipientsCount!: number;

  @attr('string') triggerData!: string;
  @attr('number') perUserDataPosition!: number;
  @attr('boolean') foundPerUserData!: boolean;
  @attr('number') perUserDataErrorCount!: number;

  @hasMany('action', { async: true, inverse: null }) workflowActions!: DS.PromiseManyArray<ActionModel>;

  @computed('workflowActions.[]')
  get filteredWorkflowActions() {
    return this.get('workflowActions').rejectBy('type', 'filter_match_delay_action');
  }

  @filterBy('filteredWorkflowActions', 'isMessaging') messagingActions!: ActionModel[];
  @filterBy('filteredWorkflowActions', 'hasEmailStats') emailStatActions!: ActionModel[];
  @filterBy('filteredWorkflowActions', 'isSplitTest') splitTestActions!: ActionModel[];

  @computed('workflowActions.[]')
  get actionIndexIncrement() {
    let hiddenAction = this.get('workflowActions').findBy('type', 'filter_match_delay_action');
    return hiddenAction ? 1 : 0;
  }

  @computed('createdAt')
  get formattedCreatedAt() {
    return this.get('moment').formatTimestamp([this.get('createdAt')], { capitalize: true });
  }

  @readOnly('formattedCreatedAt') name!: string;

  downloadErrorsLink = modelApiAction({
    path: 'download_errors',
    type: 'GET',
    after({ url }) {
      return url;
    },
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'broadcast-trigger': BroadcastTriggerModel;
  }
}
